import { ClipboardDocumentCheckIcon } from "@heroicons/react/24/outline";
import { cn } from "helpers/classNames";

type Props = {
  className?: string;
};

export const UppgiftIcon = ({ className }: Props) => (
  <ClipboardDocumentCheckIcon
    className={cn("h-4 w-4 text-gray-400", className)}
  />
);
